module.exports = __webpack_public_path__ + "img/zjh.dc05e01b.jpg";